import { render } from "./GridDBUpload.vue?vue&type=template&id=ce136afe"
import script from "./GridDBUpload.vue?vue&type=script&lang=js"
export * from "./GridDBUpload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__